import GetItShippedShippingGroups from 'components/FrictionlessCheckout/ShippingMethods/GetItShippedShippingGroups/GetItShippedShippingGroups';

export default GetItShippedShippingGroups;
